// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-content-shared {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
}

.product-detail-content-image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border-subtle);
}

.product-detail-content-image img {
  max-width: 100%;
  max-height: 320px;
  object-fit: contain;
}

.product-detail-content-image-placeholder {
  width: 100%;
  height: 240px;
  background: var(--color-light-gray);
  border-radius: 8px;
}

.product-detail-content-brand {
  margin-top: 4px;
}

.product-detail-content-name {
  margin: 0;
  line-height: 1.3;
}

.product-detail-content-type {
  margin-bottom: 4px;
}

.product-detail-content-divider {
  border: none;
  border-top: 1px solid var(--color-border-subtle);
  margin: 8px 0;
}

.product-detail-content-section-label {
  color: var(--color-dark-gray);
  margin-bottom: 4px;
}

.product-detail-content-section-value {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductDetailContent/ProductDetailContent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".product-detail-content-shared {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0;\n}\n\n.product-detail-content-image {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: var(--color-surface-muted);\n  border: 1px solid var(--color-border-subtle);\n}\n\n.product-detail-content-image img {\n  max-width: 100%;\n  max-height: 320px;\n  object-fit: contain;\n}\n\n.product-detail-content-image-placeholder {\n  width: 100%;\n  height: 240px;\n  background: var(--color-light-gray);\n  border-radius: 8px;\n}\n\n.product-detail-content-brand {\n  margin-top: 4px;\n}\n\n.product-detail-content-name {\n  margin: 0;\n  line-height: 1.3;\n}\n\n.product-detail-content-type {\n  margin-bottom: 4px;\n}\n\n.product-detail-content-divider {\n  border: none;\n  border-top: 1px solid var(--color-border-subtle);\n  margin: 8px 0;\n}\n\n.product-detail-content-section-label {\n  color: var(--color-dark-gray);\n  margin-bottom: 4px;\n}\n\n.product-detail-content-section-value {\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
